/**
 * Helper responsible for provide util format methods
 *
 * @author Jefferson Garcia
 */

import { format } from 'date-fns'

export default class FormatHelper {
  static formatDate(date, dateFormat = 'P') {
    return date && format(new Date(date), dateFormat)
  }

  static formatNumber(
    val,
    maximumFractionDigits = 2,
    minimumFractionDigits = 0
  ) {
    if (val && !isNaN(val)) {
      return (
        val &&
        parseFloat(val) &&
        parseFloat(val).toLocaleString('en-US', {
          maximumFractionDigits,
          minimumFractionDigits,
        })
      )
    }

    return 0
  }

  static formatCurrency(
    val,
    maximumFractionDigits = 2,
    minimumFractionDigits = 0,
    currency = 'USD'
  ) {
    let valFinal = 0

    if (val && !isNaN(val)) {
      valFinal = parseFloat(val)
    }

    return valFinal.toLocaleString('en-US', {
      maximumFractionDigits,
      minimumFractionDigits,
      style: 'currency',
      currency,
    })
  }

  static convertDateToUTC(date) {
    if (!(date instanceof Date)) {
      date = new Date(date)
    }

    return new Date(
      date.getUTCFullYear(),
      date.getUTCMonth(),
      date.getUTCDate(),
      date.getUTCHours(),
      date.getUTCMinutes(),
      date.getUTCSeconds()
    )
  }
}
